import { isMobile, ImportBundle } from "./utils/utils";

/*! 公共 Start */
/**
 * 头部搜索下拉
 * @function initSearch
 * @param {string} search ".header-search_box"
 * @param {string} trigger ".search-trigger"
 **/
export function initSearch(search = ".header-search_box", trigger = ".search-trigger") {
  const searchBox = $(`.pc-header ${search}`);
  if (!searchBox.length || !trigger) return;
  $(`.pc-header ${trigger}`).on("click", (event) => {
    searchBox.slideToggle(500);
    $(document).one("click", () => {
      searchBox.slideUp(500);
    });
    event.stopPropagation();
  });
  searchBox.on("click", (event) => {
    event.stopPropagation();
  });
}

/**
 * 全局搜索方法
 * @function globalSearch
 * 公共初始化所有"form.searchForm"类的的表单，注册submit事件
 *
 **/
export function globalSearch() {
  $("form.searchForm").on("submit", (event) => {
    const form = event.target;
    const module = (form.querySelector("[name=module]")! as HTMLInputElement).value;
    const keyword = (form.querySelector("[name=keyword]")! as HTMLInputElement).value;
    if (!keyword || keyword === "") {
      alert("Please enter your search");
      return false;
    }
    window.location.href = `/search/${module}/${keyword}.html`;
  });
}

/**
 * 头部导航栏Fixed
 * @function fixedsHeader
 * @param {string} id
 * @param {string} className "header-fixeds_1"
 * @param {number} H
 **/
export function fixedsHeader(id: string, className = "header-fixeds_1", H?: number) {
  const header = $(`header.${id}`)!;
  const h = header.height()!;
  if (isMobile(1024)) {
    $(header)
      .find(".trigger")
      .on("click", function () {
        $(this).toggleClass("trigger_active");
        $(this).siblings(".content_mt_ul").slideToggle(300);
      });
    $(header)
      .find(".mobile_nav .nav_bg")
      .on("click", function () {
        $("html").css("overflow-y", "unset");
        $(".mobile_nav .mobile_nav_content").removeClass("nav_show");
      });
    $(header)
      .find(".mobile_nav .cus-bars")
      .on("click", function () {
        $("html").css("overflow-y", "hidden");
        $(".mobile_nav .mobile_nav_content").addClass("nav_show");
      });
  } else {
    $(window).on("scroll", () => {
      if ($(window).scrollTop()! > (H ?? h)) {
        header.addClass(className);
      } else if ($(window).scrollTop()! === 0) {
        header.removeClass(className);
      }
    });
  }
}

/**
 * 懒加载 并 初始化FancyBox
 * @function initFancyBox
 **/
export function initFancyBox() {
  ImportBundle({ type: "css", isIndex: true }, ["https://static.yigetechcms.com/public/css/fancybox@5.0.0.min.css"]);
  ImportBundle({ type: "js", isIndex: true }, [
    {
      src: "https://static.yigetechcms.com/public/js/fancybox@5.0.0.min.js",
      fn: () => {
        if (window && window.Fancybox) {
          window.Fancybox.bind("[data-fancybox]", {
            Thumbs: {
              type: "classic",
            },
            Toolbar: {
              display: {
                left: ["infobar"],
                middle: ["zoomIn", "zoomOut", "toggle1to1", "rotateCCW", "rotateCW", "flipX", "flipY"],
                right: ["slideshow", "thumbs", "close"],
              },
            },
          });
        }
      },
    },
  ]);
}